import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["hiddenFromMembers"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Avatar } from '@infl-ts/ui-advocate-components';
import { mergeSxProps } from '@infl-ts/util-merge-sx-props';
import { Box, Typography, useMediaQuery } from '@mui/material';
import Timestamp from './timestamp';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var AdvocateAvatar = function AdvocateAvatar(_ref) {
  var avatarSize = _ref.avatarSize,
      member = _ref.member,
      opacity = _ref.opacity;
  return /*#__PURE__*/_jsx(Avatar, _objectSpread(_objectSpread({}, typeof avatarSize === 'number' ? {
    sx: {
      width: avatarSize,
      height: avatarSize,
      opacity: opacity
    }
  } : {
    size: avatarSize,
    sx: {
      opacity: opacity
    }
  }), {}, {
    member: member,
    popoverZIndex: function popoverZIndex(t) {
      return t.zIndex.aboveDrawer;
    },
    "data-element": "Avatar",
    "data-component": "AdvocateAvatar",
    "data-source-file": "advocate-section.tsx"
  }));
};

var MobileSection = function MobileSection(_ref2) {
  var member = _ref2.member,
      avatarSize = _ref2.avatarSize,
      timestamp = _ref2.timestamp,
      children = _ref2.children,
      opacity = _ref2.opacity,
      sx = _ref2.sx;
  return /*#__PURE__*/_jsxs(Box, {
    sx: mergeSxProps({
      display: 'flex',
      flexDirection: 'column'
    }, sx),
    "data-element": "Box",
    "data-component": "MobileSection",
    "data-source-file": "advocate-section.tsx",
    children: [/*#__PURE__*/_jsxs(Box, {
      sx: {
        display: 'flex',
        mb: 1.5,
        opacity: opacity
      },
      "data-element": "Box",
      "data-component": "MobileSection",
      "data-source-file": "advocate-section.tsx",
      children: [/*#__PURE__*/_jsx(AdvocateAvatar, {
        avatarSize: avatarSize,
        member: member,
        opacity: opacity,
        "data-element": "AdvocateAvatar",
        "data-component": "MobileSection",
        "data-source-file": "advocate-section.tsx"
      }), /*#__PURE__*/_jsxs(Box, {
        sx: {
          width: 1,
          pl: 2,
          pb: avatarSize === 'small' ? 0 : 1,
          display: 'flex',
          justifyContent: 'space-between'
        },
        "data-element": "Box",
        "data-source-file": "advocate-section.tsx",
        children: [/*#__PURE__*/_jsxs(Box, {
          "data-element": "Box",
          "data-source-file": "advocate-section.tsx",
          children: [/*#__PURE__*/_jsx(Typography, {
            component: "div",
            sx: {
              fontWeight: function fontWeight(t) {
                return t.typography.fontWeightBold;
              }
            },
            "data-element": "Typography",
            "data-source-file": "advocate-section.tsx",
            children: member.name
          }), member.title && /*#__PURE__*/_jsx(Typography, {
            component: "span",
            variant: "body2",
            children: member.title
          }), member.company && /*#__PURE__*/_jsxs(Typography, {
            component: "span",
            variant: "body2",
            children: [member.title ? ' at ' : ' ', member.company]
          })]
        }), timestamp ? /*#__PURE__*/_jsx(Timestamp, {
          timestamp: timestamp
        }) : null]
      })]
    }), children]
  });
};

var DesktopSection = function DesktopSection(_ref3) {
  var member = _ref3.member,
      avatarSize = _ref3.avatarSize,
      timestamp = _ref3.timestamp,
      children = _ref3.children,
      opacity = _ref3.opacity,
      sx = _ref3.sx;
  return /*#__PURE__*/_jsxs(Box, {
    sx: mergeSxProps({
      display: 'flex'
    }, sx),
    "data-element": "Box",
    "data-component": "DesktopSection",
    "data-source-file": "advocate-section.tsx",
    children: [/*#__PURE__*/_jsx(AdvocateAvatar, {
      avatarSize: avatarSize,
      member: member,
      opacity: opacity,
      "data-element": "AdvocateAvatar",
      "data-component": "DesktopSection",
      "data-source-file": "advocate-section.tsx"
    }), /*#__PURE__*/_jsx(Box, {
      sx: {
        display: 'flex',
        width: 1,
        justifyContent: 'space-between',
        ml: 2
      },
      "data-element": "Box",
      "data-source-file": "advocate-section.tsx",
      children: /*#__PURE__*/_jsxs(Box, {
        sx: {
          width: 1
        },
        "data-element": "Box",
        "data-source-file": "advocate-section.tsx",
        children: [/*#__PURE__*/_jsxs(Box, {
          sx: {
            display: 'flex',
            justifyContent: 'space-between',
            opacity: opacity
          },
          "data-element": "Box",
          "data-source-file": "advocate-section.tsx",
          children: [/*#__PURE__*/_jsxs(Box, {
            sx: {
              pb: avatarSize === 'small' ? 0 : 1
            },
            "data-element": "Box",
            "data-source-file": "advocate-section.tsx",
            children: [/*#__PURE__*/_jsx(Typography, {
              component: "span",
              sx: {
                fontWeight: function fontWeight(t) {
                  return t.typography.fontWeightBold;
                }
              },
              "data-element": "Typography",
              "data-source-file": "advocate-section.tsx",
              children: member.name
            }), member.title && /*#__PURE__*/_jsx(Typography, {
              component: "span",
              variant: "body2",
              sx: {
                color: function color(t) {
                  return t.palette.text.secondary;
                },
                ml: 1
              },
              children: member.title
            }), member.company && /*#__PURE__*/_jsxs(Typography, {
              component: "span",
              variant: "body2",
              sx: {
                color: function color(t) {
                  return t.palette.text.secondary;
                },
                mr: 1
              },
              children: [member.title ? ' at ' : ' ', member.company]
            })]
          }), timestamp ? /*#__PURE__*/_jsx(Timestamp, {
            timestamp: timestamp
          }) : null]
        }), children]
      })
    })]
  });
};

var AdvocateSection = function AdvocateSection(_ref4) {
  var hiddenFromMembers = _ref4.hiddenFromMembers,
      rest = _objectWithoutProperties(_ref4, _excluded);

  var isMobile = useMediaQuery(function (theme) {
    return theme.breakpoints.down('md');
  });
  var infoOpacity = hiddenFromMembers ? 0.4 : 1;
  return isMobile ? /*#__PURE__*/_jsx(MobileSection, _objectSpread({
    opacity: infoOpacity
  }, rest)) : /*#__PURE__*/_jsx(DesktopSection, _objectSpread({
    opacity: infoOpacity
  }, rest));
};

export default AdvocateSection;